// Module
var code = "<!-- ko template: { nodes: $componentTemplateNodes } -->\n<!-- /ko -->\n";
// Exports
module.exports = code;